<!-- New Fax Dialog  -->
<p-dialog [modal]="true" appendTo="body" [(visible)]="newFaxVisible" [style]="{ width: '85vw', height: '85vh'}"
    (onHide)="cancelButton($event)" header="Send Fax">
    <div class="w12 p-5 formgrid grid">
        <ng-container *ngIf="handlerReady; else notReadyBlock">
            <div class="field col-6 md:col-4 mb-4">
                <span class="p-float-label">
                    <p-dropdown id="faxTypeInput"
                        [options]="faxTypeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Fax Type"
                        [(ngModel)]="selectedFaxType"
                        (onChange)="faxTypeChanged()"
                        [style]="{ width: '100%' }">
                    </p-dropdown>
                    <label for="faxTypeInput">Fax Type</label>
                </span>
            </div>

            <div class="field col-6 md:col-4 mb-4">
                <ng-container *ngIf="pendingFax; else fromPlaceholder">
                    <span class="p-float-label">
                        <input id="fromInput" type="text" [required]="true" [(ngModel)]="pendingFax.from" pInputText
                            [style]="{ width: '305px' }" maxlength="40" />
                        <label for="fromInput">From</label>
                    </span>
                </ng-container>
                <ng-template #fromPlaceholder>
                    <span class="p-float-label">
                        <input id="fromInputDisabled" type="text" value="" pInputText
                            [style]="{ width: '305px' }" maxlength="40" disabled />
                        <label for="fromInputDisabled">From</label>
                    </span>
                </ng-template>
            </div>

            <ng-container *ngIf="pendingFax">
                <div class="col-12">
                    <div class="field col-6 md:col-6">
                        <span class="p-float-label">
                            <input id="attnInput" type="text" [required]="true" [(ngModel)]="pendingFax.attn" pInputText
                                [style]="{ width: '100%' }" maxlength="40" />
                            <label for="attnInput">Attn</label>
                        </span>
                    </div>

                    <div class="field col-6 md:col-6 mb-4">
                        <span class="p-float-label">
                            <p-inputMask mask="(999) 999-9999" id="faxNumberInput" type="text" [required]="true"
                                [(ngModel)]="pendingFax.faxNumber"></p-inputMask>
                            <label for="faxNumberInput">Fax Number</label>
                        </span>
                    </div>
                </div>

                <div class="field col-12 mb-4">
                    <span class="p-float-label">
                        <input id="subInput" type="text" [required]="true" [(ngModel)]="pendingFax.subject" pInputText
                            [style]="{ width: '600px' }" maxlength="255" />
                        <label for="subInput">Subject</label>
                    </span>
                </div>
                <div class="field col-12 mb-4">
                    <span class="p-float-label">
                        <textarea id="notesInput" type="text" [required]="true" [(ngModel)]="pendingFax.notes" pInputTextarea
                            [style]="{ width: '600px', height: '200px' }"></textarea>
                        <label for="notesInput">Notes</label>
                    </span>
                </div>

                <div class="field col-12">
                    <ng-container *ngFor="let entry of fileEntryList; trackBy: trackByLabel">
                        <p-divider align="left" type="solid">
                            {{ entry[0] }}
                        </p-divider>
                        <div *ngFor="let a of entry[1]; trackBy: trackByField" class="flex p-2 align-items-center">
                            <p-checkbox [(ngModel)]="selectedFilesToSend" [value]="a.id" name="selectedAttachments" /> <span
                                class="ml-2">{{a.fileName}} <p-chip>{{a.fileCategory}}</p-chip></span>
                        </div>
                    </ng-container>
                </div>

                <div class="col-12 flex align-items-center justify-content-center">
                    <span class="p-buttonset">
                        <button pButton pRipple label="Cancel" class="p-button-small p-button-danger"
                            (click)="cancelButton($event)"></button>
                        <button active pButton pRipple [disabled]="!saveButtonActive" label="Send"
                            class="p-button-small p-button-success" (click)="saveButton($event)"></button>
                    </span>
                </div>
            </ng-container>

        </ng-container>

        <ng-template #notReadyBlock>
            <div class="col-12">
                <p style="margin-top:1rem;">This encounter is not able to send faxes at this time. Please try again later.</p>
            </div>
        </ng-template>
    </div>
</p-dialog>

<!-- Mouseover Panel  -->
<p-overlayPanel #details [style]="{width: '30vw'}">
    <ng-template pTemplate>
        <div class="grid flex">
            <div class="col-6">
                To: {{selectedFax?.attn}} {{selectedFax?.faxNumber}}
            </div>
            <div class="col-6">
                Sent: {{selectedFax?.faxSendTime | date:'short'}}
            </div>
            <div class="col-6">
                From: {{selectedFax?.from}}
            </div>
            <div class="col-6">
                Complete: {{selectedFax?.faxCompleteTime | date: 'short'}}
            </div>
            <div class="col-6">
                Status: {{selectedFax?.status}}
            </div>
            <div class="col-6">
                Pages (Complete/Total): {{selectedFax?.pagesSent}}/{{selectedFax?.totalPages}}
            </div>
            <div class="col-6">
                Subject: {{selectedFax?.subject}}
            </div>
            <div class="col-6">
                Files: <div *ngFor="let f of faxFiles(selectedFax?.attachmentIds!)"> {{f.fileName}} - {{f.fileType}}
                </div>
            </div>
            <div class="col-12">
                Notes: {{selectedFax?.notes}}
            </div>
        </div>
    </ng-template>
</p-overlayPanel>


<p-table [value]="faxes" dataKey="id" scrollHeight="400px">
    <ng-template pTemplate="caption">
        <div class="grid flex align-items-center">
            <div class="col-10 table-header">
                Faxes
            </div>
            <div class="col-2">
                <button pButton pRipple type="button" icon="pi pi-plus" class="p-button-rounded"
                    (click)="newFax()">&nbsp;New</button>
            </div>
        </div>
        <table width="100%">
            <tr>
                <td width="20%">Date</td>
                <td width="50%">To</td>
                <td width="15%">Pgs/Files</td>
                <td width="15%">Status</td>
            </tr>
        </table>
    </ng-template>
    <ng-template pTemplate="body" let-ef>
        <tr (mouseenter)="selectedFax=ef; details.toggle($event)" (mouseout)="details.toggle($event)">
            <td>
                <table width="100%">
                    <tr>
                        <td width="20%" style="font-weight:bold;">{{ef.faxSendTime | date:'shortDate'}}</td>
                        <td width="55%" style="font-weight:bold;">{{ef.attn.substr(0,25)}}</td>
                        <td width="10%" style="font-weight:bold;">{{ef.pagesSent}} / {{ef.attachmentIds.length}}</td>
                        <td width="15%" style="font-weight:bold;"><span>{{ef.status}}</span><span
                                *ngIf="ef.status == 'Sending'"><i class="pi pi-spin pi-spinner"
                                    style="font-size: 1rem"></i></span></td>
                    </tr>
                    <tr>
                        <td colspan="4" style="background:#ffffff;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ef.subject}}</td>
                    </tr>
                </table>
            </td>
        </tr>
    </ng-template>
</p-table>